import Vue from 'vue'
import moment from 'moment'

/**
 * directive: 年齢を出力する
 * @param { string } age - 生年月日
 * <span v-age="2000-01-01"></span>
 * => 17歳
 */
Vue.directive('age', {
  bind(el, bindings) {
    const { value } = bindings
    const diff = Math.abs(moment(value).diff(moment(), 'years'))
    Object.assign(el, { textContent: `${diff}歳` })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/age.js